import { 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot, 
    line,
    LINE_ANIMATION_TIME,
    getTimeByLayers
} from '../../initials';

export class LineBottomRightTopLeft {
        constructor({
            fromRowIndex,
            fromDotIndex,
            toRowIndex,
            toDotIndex,
            dots,
        }) {
            this.fromRowIndex = fromRowIndex;
            this.fromDotIndex = fromDotIndex;
            this.toRowIndex = toRowIndex;
            this.toDotIndex = toDotIndex;
            this.dots = dots;
    
        }

        static getAnimationSettings() {
            return {
                avaiableForMultipleLevels: true,
                type: 'LineBottomRightTopLeft',
                fromBallPositionByDot: BallPositionByDot.BOTTOM_RIGHT,
                toBallPositionByDot: BallPositionByDot.TOP_LEFT,
            };
        }

        getAnimationTime() {
            return getTimeByLayers(this.toRowIndex, this.fromRowIndex, LINE_ANIMATION_TIME);
        }
    
        animate(time) {    
            const fullTime = this.getAnimationTime();
            const t = time / fullTime;

            const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
            const endDot = this.dots[this.toRowIndex][this.toDotIndex];

            const startXY = getNotCenteredCoordinateForAnimationByAngle(startDot.dotX, startDot.dotY, 7 * Math.PI / 4);
            const endXY = getNotCenteredCoordinateForAnimationByAngle(endDot.dotX, endDot.dotY, 3 * Math.PI / 4);

            return {
                x: line(
                    startXY.x, 
                    endXY.x, 
                    t,
                ),
                y: line(
                    startXY.y, 
                    endXY.y, 
                    t,
                ),
            };

        }
}